// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPlpTable = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12,12 L16,12 L16,16 L12,16 Z M12,6 L16,6 L16,10 L12,10 Z M12,0 L16,0 L16,4 L12,4 Z M0,12 L4,12 L4,16 L0,16 Z M0,6 L4,6 L4,10 L0,10 Z M0,0 L4,0 L4,4 L0,4 Z M6,12 L10,12 L10,16 L6,16 Z M6,6 L10,6 L10,10 L6,10 Z M6,0 L10,0 L10,4 L6,4 Z"
            />
        </svg>
    );
};

export default React.memo(IconPlpTable);
